import { HttpMethod } from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { GET_FILE_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';
import { GetExportFileResponse } from './types';

export function useGetExportFileQuery(id: string, workspaceId: string) {
  return useBaseQuery<void, GetExportFileResponse>(
    [id, workspaceId],
    {
      url: `${GET_FILE_ROOT_ENDPOINT}/${workspaceId}/tasks/${id}`,
      method: HttpMethod.get,
      params: {
        action: 'export',
      },
    },
    {}
  );
}
